import { Bar } from "react-chartjs-2";
import { CategoryScale, Chart, LinearScale, BarElement, Tooltip, Legend, Colors, ChartData } from "chart.js";
import { Box, Typography } from "@mui/material";

Chart.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip, Colors);

interface BarChartProps {
  chartData: ChartData<"bar", number[], unknown>;
  title?: string;
}

export const BarChart = ({
  chartData,
  title = "Visits Last 7 Days",
}: BarChartProps) => {
  return (
    <Box sx={{ marginTop: 2, width: "500px" }}>
      <Typography variant="h6" sx={{ textAlign: "center" }}>{title}</Typography>
      <Bar
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: "Amount of Visits"
            },
            legend: {
              display: true
            },
            tooltip: {
              enabled: true
            },
          }
        }
        }
      />
    </Box>
  );
};